import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ComponentDataResolver } from '@core/dynamic-components/types';
import { booleanStringCheck } from '@shared/ui/utils/global-utils/boolean-string-check';
import { BreadcrumbsItem } from 'jb-component-library';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'jb-breadcrumb-container',
  templateUrl: './breadcrumb-container.component.html',
})
export class BreadcrumbContainerComponent {
  heroExists: boolean;
  breadcrumbs: BreadcrumbsItem;
  hideBreadcrumbs: boolean;
  pageHeaderCrumbTheme = 'light';
}

export const breadcrumbContainerResolver: ComponentDataResolver = (
  registry,
  data,
): any => {
  const hideBreadcrumbs = booleanStringCheck(
    data.breadcrumbs?.[0]?.hideBreadcrumbs,
  );
  const heroExists = Boolean(registry['hero']) || Boolean(registry['pageHero']);
  return {
    heroExists,
    hideBreadcrumbs,
    breadcrumbs: data.breadcrumbs ? data.breadcrumbs[0] : data,
  };
};
